const target = {
    username: 'Benutzername',
    user: 'Benutzer',
    userAndPw: '@:target.username und @:input.password',
    setting: 'Einstellung | Einstellungen',
    profile: 'Profil',
    location: 'Location',
    order: {
        paypal: 'PayPal'
    },
    product: 'Produkt | Produkte',
    request: 'Anfrage',
    list: 'Liste',
    required: 'Pflichtfeld | Pflichtfelder',
    field: 'Feld | Felder',
    deliverer: 'Lieferant | Lieferanten',
    tag: 'Kategorie | Kategorien',
    password: 'Passwort',
    permission: 'Berechtigung | Berechtigungen'
}
export default target
